import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  KeyboardAvoidingView,
  ScrollView,
} from "react-native";
import Switch from "../components/ToggleSwitch";
import Text from "../components_v2/TextFont";
import * as Actions from "../actions/DeviceActions";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import Theme from "../argon-ui/Theme";
import Loading from "../components/Loading";
import UrlPicker from "../components/UrlPicker";
import InputBase from "../nativeBase-ui/InputBase";
import { faEdit, faPlay, faRepeatAlt } from "../../assets/consts/faCharCodes";
import { HStack } from "native-base";
import Select from "../nativeBase-ui/Select";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";

import axios from "axios";
import Spinner from "../components_v2/Spinner";
import { testSmartSpeaker } from "../actions/SmartSpeakerActions";
// === Const ===
const INPUT_HEIGHT = 40;
const DEFAULT_IP_SERVER = "Manual";
const defaultSmartSpeakerServerListValue = {
  friendlyName: translate("smartSpeaker.orImportServerManually"),
  ip: DEFAULT_IP_SERVER,
};

class SmartSpeakerFormScreen extends Component {
  constructor(props) {
    super(props);
    let { areaId, areaUId, deviceId, deviceUId } =
      this.props.navigation.state.params;
    this.state = {
      areaId,
      areaUId,
      deviceId: deviceId || 0,
      deviceUId: deviceUId || null,
      deviceName: "",
      protocol: "http", //http , https
      ip: "",
      port: "80",
      serverHref: "",
      isLoading: true,
      accessToken: "",
      storageServerId: null,
      validation_deviceName_hasError: false,
      validation_IP_hasError: false,
      showingValidationErrors: false,
      validationErrors: [],
      showOnHomeScreen: true,
      showManualIP: false,
      isLoadingIpList: true,
      smartSpeakerServerList: [],
      searchIpLoading: false,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.DeviceList"),
  });
  componentDidMount() {
    const accessToken = this.props.appReducer?.currentServer.accessToken;
    let serverUrl = this.props.appReducer?.serverUrl;
    if (!serverUrl.endsWith("/")) {
      serverUrl = serverUrl + "/";
    }
    // === found Smart Speaker Server list ===
    this.fetchIpLocalList(serverUrl, accessToken);

    // get data from reducer using state.deviceId
    if (this.state.deviceUId || this.state.deviceId) {
      var model = {};
      for (var i in this.props.reducer.list) {
        // get model from reducer
        if (
          (this.state.deviceUId &&
            this.props.reducer.list[i].deviceId == this.state.deviceId) ||
          this.props.reducer.list[i].deviceUId == this.state.deviceUId
        ) {
          model = this.props.reducer.list[i];

          this.setState({
            deviceName: model.deviceName,
            ip: model.ip,
            port: model.port,
            protocol: model.protocol,
            showOnHomeScreen: model.showOnHomeScreen,
            storageServerId: model.storageServerId || "",
          });
          break;
        }
      }
    }
    this.setState({
      accessToken,
      showManualIP: this.state.deviceUId || this.state.deviceId,
      isLoading: false,
    });
  }
  fetchIpLocalList = async (
    serverUrl,
    accessToken,
    checkCurrentList = false
  ) => {
    try {
      const res = await axios.get(`${serverUrl}SmartSpeakers/Found`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (checkCurrentList) {
        const someNewItem = res.data.filter(
          ({ ip: ip1 }) =>
            !this.state.smartSpeakerServerList.some(
              ({ ip: ip2 }) => ip2 === ip1 && ip2 !== DEFAULT_IP_SERVER
            )
        );
        if (someNewItem.length === 0) {
          this.refreshIpListHandler(serverUrl, accessToken);
          return;
        }
      }
      this.setState({
        smartSpeakerServerList: [
          ...res.data,
          defaultSmartSpeakerServerListValue,
        ],
        isLoadingIpList: false,
      });
    } catch (error) {
      console.log("error get ip local list", error);
      this.setState({
        smartSpeakerServerList: [defaultSmartSpeakerServerListValue],
        isLoadingIpList: false,
      });
    }
  };
  refreshIpListHandler = async (severUrl, accessToken) => {
    try {
      const res = await axios.get(`${severUrl}SmartSpeakers/ReScan`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      this.setState({
        smartSpeakerServerList: [
          ...res.data,
          defaultSmartSpeakerServerListValue,
        ],
      });
    } catch (error) {
      console.log("error get ip local list", error);
    } finally {
      this.setState({
        isLoadingIpList: false,
      });
    }
  };
  onRefreshIpListHandler = () => {
    this.setState({ isLoadingIpList: true, showManualIP: false }, () => {
      const accessToken = this.props.appReducer?.currentServer.accessToken;
      let serverUrl = this.props.appReducer?.serverUrl;
      if (!serverUrl.endsWith("/")) {
        serverUrl = serverUrl + "/";
      }
      this.fetchIpLocalList(
        serverUrl,
        accessToken,
        true // check current list
      );
    });
  };
  goBack = () => {
    // this.props.navigation.navigate("DeviceList", { areaId: this.state.areaId });

    if (this.props.navigation) {
      // go back to prev screen
      this.props.navigation.goBack();

      // callback
      this.props.navigation.state.params.onGoBack &&
        this.props.navigation.state.params.onGoBack(DeviceTypes.SMART_SPEAKER);

      return false;
    }
  };

  goToDeviceLog = () => {
    this.props.navigation.navigate("DeviceLogs", {
      deviceId: this.state.deviceId,
      deviceUId: this.state.deviceUId,
    });
  };

  save = () => {
    var model = {
      // areaId: this.state.areaId, // areaId foreign key removed because data model changed into many-to-many relationship.
      deviceId: this.state.deviceId,
      deviceUId: this.state.deviceUId,
      deviceName: this.state.deviceName,
      ip: this.state.ip,
      port: this.state.port,
      protocol: this.state.protocol,
      areaId: this.state.areaId,
      areaUId: this.state.areaUId,
      showOnHomeScreen: this.state.showOnHomeScreen,
      storageServerId: this.state.storageServerId || null,
      buildingId: this.props.appReducer.currentBuilding.buildingId,
    };

    // validation
    let errors = [];
    if (!model.deviceName) {
      errors.push(
        `${translate("device.deviceName")} ${translate("app.isRequired")}`
      );
      this.setState({ validation_deviceName_hasError: true });
    }

    if (!model.ip) {
      errors.push(`${translate("device.ip")} ${translate("app.isRequired")}`);
      this.setState({ validation_IP_hasError: true });
    }

    if (errors.length > 0) {
      this.showValidationAlert(errors);
      return;
    }
    // end of validation

    // if valid
    if (model.deviceId || model.deviceUId) {
      this.props.update(model, this.state.accessToken);
    } else {
      this.props.add(model, this.state.accessToken);
    }
    this.goBack();
  };

  showValidationAlert = (errors = []) => {
    this.setState({
      showingValidationErrors: true,
      validationErrors: [...errors],
    });
  };

  dismissValidationAlert = () => {
    this.setState({
      showingValidationErrors: false,
      validationErrors: [],
    });
  };
  onTestSpeaker = () => {
    const { ip, storageServerId, accessToken } = this.state;
    if (ip && ip !== DEFAULT_IP_SERVER && storageServerId) {
      this.setState({ searchIpLoading: true }, () => {
        this.props.testSmartSpeaker(ip, storageServerId, accessToken);
      });
      setTimeout(() => {
        this.setState({ searchIpLoading: false });
      }, 2000);
    }
  };
  renderRefreshIpListIcon = (message = "") => {
    if (this.state.isLoadingIpList) {
      return (
        <View style={style.iconRefresh}>
          <Spinner />
        </View>
      );
    }
    return (
      <ArButton
        color="primary"
        style={style.iconRefresh}
        onPress={this.onRefreshIpListHandler}
        icon={faRepeatAlt}
        // style={{ flex: 1, marginBottom: 0, marginTop: 10 }}
      >
        {message}
      </ArButton>
      // <IconButton
      //   colorScheme="gray"
      //   variant="ghost"
      //   style={style.iconRefresh}
      //   onPress={this.onRefreshIpListHandler}
      //   icon={
      //     <FontAwesomeIcon
      //       icon={faRepeatAlt}
      //       size={15}
      //       color={Theme.COLORS.PRIMARY}
      //     />
      //   }
      // />
    );
  };
  renderTestSmartSpeakerIcon = () => {
    return (
      <ArButton
        color="primary"
        onPress={this.onTestSpeaker}
        icon={faPlay}
        style={{ flex: 1, marginBottom: 0, marginTop: 10 }}
        isLoading={this.state.searchIpLoading}
      >
        {translate("smartSpeaker.testSpeaker", {
          ip: this.state.ip,
        })}
      </ArButton>
    );
  };
  render() {
    if (this.state.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else {
      const screenTitle =
        this.state.deviceId || this.state.deviceUId
          ? this.state.deviceName || translate("app.noName")
          : translate("device.defineNewDevice");
      return (
        <KeyboardAvoidingView
          behavior="height"
          style={{ flex: 1 }}
          enabled={true}
          keyboardVerticalOffset={80}
        >
          <ScrollView style={style.container}>
            <Text style={style.screenTitle}>{screenTitle}</Text>
            {/* deviceName */}
            <InputBase
              containerStyle={{ marginVertical: 10 }}
              isInValid={this.state.validation_deviceName_hasError}
              label={translate("device.deviceName")}
              onChangeText={(txt) =>
                this.setState({
                  deviceName: txt,
                  validation_deviceName_hasError: txt.length == 0,
                })
              }
              value={this.state.deviceName}
              icon={faEdit}
            />
            {!this.state.showManualIP ? (
              <HStack space="2" alignItems="flex-end">
                <Select
                  containerStyle={{ flex: 1 }}
                  label={translate("smartSpeaker.serverIPList")}
                  placeholder={translate("app.selectAnItem")}
                  // data={this.props.reducer.smartSpeakerServer.length.map((a) => {
                  data={this.state.smartSpeakerServerList.map((a) => {
                    return {
                      label: a.friendlyName + ` (${a.ip})`,
                      value: a.ip,
                    };
                  })}
                  value={this.state.ip || undefined}
                  onChangeText={(value, index, data) => {
                    if (value === DEFAULT_IP_SERVER) {
                      this.setState({
                        showManualIP: true,
                      });
                    } else {
                      this.setState({
                        ip: value,
                      });
                    }
                  }}
                />
                {this.renderRefreshIpListIcon()}
              </HStack>
            ) : (
              <View style={{ alignItems: "flex-end" }}>
                <ArButton
                  color="primary"
                  onPress={this.onRefreshIpListHandler}
                  icon={faRepeatAlt}
                  style={{
                    flex: 1,
                    marginBottom: 0,
                    marginTop: 10,
                    width: "100%",
                  }}
                >
                  {translate("smartSpeaker.searchIp")}
                </ArButton>
                {/* {this.renderRefreshIpListIcon()} */}
                <UrlPicker
                  label={translate("device.ip")}
                  protocol={this.state.protocol}
                  domain={this.state.ip}
                  port={this.state.port}
                  onChange={(deviceAddress, uri) => {
                    this.setState({
                      protocol: uri.protocol,
                      ip: uri.domain,
                      port: uri.port,
                    });
                  }}
                />
              </View>
            )}
            <View style={{ marginTop: 10, width: "100%" }}>
              <Select
                value={this.state.storageServerId}
                placeholder={translate("app.selectAnItem")}
                label={translate("device.storageServer")}
                data={this.props.reducer.list
                  .filter((d) => d.deviceType == DeviceTypes.TAPLIFE_CONTROLLER)
                  .map((d) => {
                    return {
                      value: d.taplifeControllerId || "",
                      label: d.deviceName,
                    };
                  })}
                onChangeText={(storageServerId) => {
                  this.setState({ storageServerId });
                }}
              />
            </View>
            {this.state.ip &&
              this.state.storageServerId &&
              this.renderTestSmartSpeakerIcon()}
            {/* device local address */}

            <HStack
              space="2"
              style={{
                flexDirection: "row",
                marginTop: 20,
                alignItems: "center",
              }}
            >
              <Switch
                isOn={this.state.showOnHomeScreen}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  this.setState({
                    showOnHomeScreen: !this.state.showOnHomeScreen,
                  });
                }}
                animationSpeed={0}
              />
              <Text>{translate("device.showOnHomeScreen")}</Text>
            </HStack>

            <HStack space={2} style={{ marginVertical: 10 }}>
              <ArButton
                color="primary"
                onPress={() => this.save()}
                style={{ flex: 1 }}
              >
                {translate("app.save")}
              </ArButton>
              <ArButton
                color="muted"
                variant="outline"
                onPress={() => this.goBack()}
                style={{ flex: 1 }}
              >
                {translate("app.goBack")}
              </ArButton>
            </HStack>
            {(this.state.deviceId > 0 || this.state.deviceUId) && (
              <ArButton
                color="success"
                style={{ width: "100%" }}
                onPress={() => this.goToDeviceLog()}
              >
                {translate("area.logs")}
              </ArButton>
            )}
          </ScrollView>
          {/** validation alert */}
          {this.state.showingValidationErrors && (
            <AlertDialogBase
              isOpen={true}
              cancelText={translate("app.close")}
              cancelVariant="outline"
              onClose={() => this.dismissValidationAlert()}
            >
              <Text>{" - " + this.state.validationErrors.join("\r\n - ")}</Text>
            </AlertDialogBase>
          )}
        </KeyboardAvoidingView>
      );
    }
  }
}

const style = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingHorizontal: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
  },
  inputLabel: {
    fontWeight: "500",
    fontSize: 15.4,
    marginBottom: 4,
  },
  CheckBox: {
    alignSelf: "center",
    padding: 0,
    margin: 0,
    width: 16,
  },
  iconRefresh: {
    borderRadius: 10,
    marginBottom: 8,

    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 0,
    width: INPUT_HEIGHT,
    height: INPUT_HEIGHT,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (device, accessToken) =>
      dispatch(Actions.AddSmartSpeaker(device, accessToken)),
    update: (device, accessToken) =>
      dispatch(Actions.UpdateSmartSpeaker(device, accessToken)),
    testSmartSpeaker: (ip, storageServerId, accessToken) =>
      dispatch(testSmartSpeaker(ip, storageServerId, accessToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmartSpeakerFormScreen);
